"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateVarIdxSuffix = exports.keyByVariableName = void 0;
__exportStar(require("./formulaInput"), exports);
__exportStar(require("./formulaNode"), exports);
__exportStar(require("./prettyFormula"), exports);
__exportStar(require("./inspectDependencies"), exports);
__exportStar(require("./rangeVariables"), exports);
const keyByVariableName = (variables, options = {}) => {
    const errors = [];
    const seenVariable = new Set();
    const keyMap = variables.reduce((res, { name, value }) => {
        if (!options.ignoreDuplicates) {
            if (seenVariable.has(name)) {
                errors.push(`Detected duplicate variable [name:${name}]`);
            }
        }
        seenVariable.add(name);
        res[name] = value ?? null;
        return res;
    }, {});
    return { keyMap, errors };
};
exports.keyByVariableName = keyByVariableName;
const generateVarIdxSuffix = (idx) => {
    // This will ultimately be fed into "FormulaEngine" ("HyperFormula"),
    // which doesn't allow brackets in the name, so using this rather than [idx].
    // https://hyperformula.handsontable.com/guide/named-expressions.html#naming-rules
    return `_idx${idx}`;
};
exports.generateVarIdxSuffix = generateVarIdxSuffix;
//# sourceMappingURL=index.js.map